import { PraticaSection } from './pratica-section';
import { PraticaStats } from './pratica-stats';

export enum PraticaAction {
  SAVE = 'save',
  CLOSE = 'close',
  SIGN = 'sign',
  CONFIRM = 'confirm',
}

export type PraticaEvent = PraticaAction | PraticaSection | PraticaStats;
